




















import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Loading from '@/components/Global/Loading.vue';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';
import Alert from '@/components/Global/Alert.vue';
import PolicySelector from '@/components/Global/PolicySelector.vue';

import Welcome from '@/components/Global/Welcome.vue';
import InvoicesList from '@/components/BillingStatements/InvoicesList.vue';

import PolicyDocuments, { PolicyDocumentMetadata, PolicyPacket } from '@/services/PolicyDocuments';
import Policy from '@/services/Policy';
import SelectField from '@/components/Form/SelectField.vue';

import store from '@/store/index';

import * as Sentry from '@sentry/browser';

@Component({
	name: 'PageInvoices',
	components: {
		Loading,
		InvoicesList,
		Sidebar,
		Alert,
		SelectField,
		Welcome,
		PolicySelector,
	},
})
export default class Invoices extends Vue {
	@Getter('activePolicies', { namespace: 'Policy' }) private policies: any;
	private error: boolean = false;
	private loading: boolean = true;
	private invoices: any[] = [];
	private policy: string = '';

	private async created() {
		try {
			// Fetch Policies - Might have updated data
			await Policy.setPolicyData();

			// Get an array of all the policy numbers for the current user.
			// this.policies = store.getters['Policy/policies'];
		} catch (error) {
			Sentry.captureException(error);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}

	private async changePolicy(policyNumber) {
		try {
			this.loading = true;
			this.policy = policyNumber;
			this.policies.forEach(policy => {
				if (policy.policy_number === this.policy) {
					policyNumber = policy.policy_number;
				}
			});

			const metadata: PolicyDocumentMetadata[] = await PolicyDocuments.getPolicyDocumentMetadatas(
				this.policy,
			);

			// Convert into an array of PolicyPackets.
			this.invoices = PolicyDocuments.filterBillingStatementsForMmic(metadata);
		} catch (e) {
			Sentry.captureException(e);
		} finally {
			this.loading = false;
		}
	}
}
